import { __awaiter } from "tslib";
import { Connection, PublicKey } from "@solana/web3.js";
import { getHashedName, getNameAccountKey, NameRegistryState, } from "@bonfida/spl-name-service";
import { defaultRPC } from "../lib/solana";
// TODO consolidate this with 'packages/frontend/src/solana/fetchSNSPublicKeyForDomain.ts'
export const fetchSNSPublicKeyForDomain = (handle, connection) => __awaiter(void 0, void 0, void 0, function* () {
    const updateDomainName = handle
        .toLowerCase()
        .trim()
        .replace(/\.sol$/i, "");
    const hashedName = yield getHashedName(updateDomainName);
    const SOL_TLD_AUTHORITY = new PublicKey("58PwtjSDuFHuUkYjH9BYnnQKHfwo9reZhC2zMJv9JPkx");
    const domainKey = yield getNameAccountKey(hashedName, undefined, SOL_TLD_AUTHORITY);
    const { registry } = yield NameRegistryState.retrieve(connection || new Connection(defaultRPC("mainnet-beta")), domainKey);
    return registry.owner.toBase58();
});
